/**
 * A Flächenbeschreibung has no number of its own — Fläche × Planum × Sondage
 * is its key, so that triple is also how it is named: "Fl. 3, Pl. 1" or
 * "Fl. 3, Pl. 1, Sd. 2", in the Lage grammar of `locationLabel`. A blank
 * Planum or Sondage is left out ("Fl. 3").
 */
export function areaDescriptionLocation({
    area,
    planum,
    sondage
}: {
    area: string;
    planum: string;
    sondage?: string;
}): string {
    const parts = [`Fl. ${area.trim() || '—'}`];
    if (planum.trim()) {
        parts.push(`Pl. ${planum.trim()}`);
    }
    if (sondage?.trim()) {
        parts.push(`Sd. ${sondage.trim()}`);
    }
    return parts.join(', ');
}

/**
 * The triple as the uniqueness check compares it: trimmed and case-blind, so
 * "Nord" and "nord " are the same Fläche. No Sondage is a key of its own — the
 * whole Planum — beside every Sondage of it.
 */
export function areaDescriptionKey(
    area: string,
    planum: string,
    sondage: string
): string {
    return [area, planum, sondage]
        .map((part) => part.trim().toLowerCase())
        .join('\u0000');
}
